/* eslint-disable */
import moment from 'moment';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
// import { useHistory } from 'react-router';
import analyticsAction from '../../../../Actions/analytics.actions';
import { OutwardingImageResults } from '../../../../Components/Analytics/Outwarding';
import { DefectImageModal } from '../../../../Components/Modals';
import { liveQCServices } from '../../../../Services/LiveQC';
import styles from './WastageImagesPage.module.css';
import wastageAnalyticsServices from '../../../../Services/Analytics Services/wastage-analytics.services';
import ImagesFinder from '../../../../Components/ImagesFinder/ImagesFinder';
import { Filter } from 'lucide-react';
import { Button } from '@mui/material';
import drawerActions from '@/Actions/drawer.actions';
import { filtersInfoChip } from '@/Helpers';
import { SelectPicker } from 'rsuite';

// const source =
// 'https://www.thespruceeats.com/thmb/vJUFf6L4p8y9Cn_1pE9Z7Ua9uok=/3000x2001/filters:fill(auto,1)/indian-style-burger-1957599-hero-01-266103a4bb4e4ee7b5feb4da2d2e99da.jpg';

const WastageImagesPage = (props) => {
	const [filters, setFilters] = useState({
		store: null,
		processTypes: null,
		products: [],
		brand: null,
		identification: 'Both',
		dateRange: {
			active: false,
			from: new Date(),
			to: new Date(),
		},
	});

	const {
		allWastageResults,
		fetchWastageImages,
		resetWastageImages,
		updateWastageImagesById,
		toggleFiltersDrawer,
	} = props;

	useEffect(() => {
		resetWastageImages();
	}, []);

	const [pageLimit, setPageLimit] = useState(6);

	const submitFindRequest = ({
		store = null,
		processTypes = null,
		products = [],
		dateRange = {},
		brand = null,
		identification = 'Both',
		skuType = null,
	}) => {
		resetWastageImages();
		setFilters({
			store,
			processTypes,
			products,
			dateRange,
			identification,
			brand,
			skuType,
		});
		const data = {
			storeId: store?.id,
			products: products?.id,
			processTypes: processTypes?.id,
			brandId: brand?.id,
			identification,
			skuType: skuType?.toUpperCase(),
			dateRangeFilter: dateRange?.active
				? {
					from: moment(dateRange?.from).format('YYYY-MM-DD'),
					to: moment(dateRange?.to).format('YYYY-MM-DD'),
				}
				: {},
		};
		fetchWastageImages({
			entity: 'WASTAGE_ANALYSIS',
			method: 'FIND_WASTAGE_IMAGES',
			req: {
				data,
				params: {
					limit: pageLimit,
				},
			},
		});
	};

	const fetchWastageImagesById = async ({ pageNo, productId }, index) => {
		const response = await wastageAnalyticsServices.fetchWastageImagesById({
			params: {
				page: pageNo,
				limit: pageLimit,
			},
			data: {
				storeId: filters?.store?.id,
				brandId: filters?.brand?.id,
				processTypes: filters?.processTypes?.id,
				identification: filters?.identification,
				productId,
				dateRangeFilter: filters?.dateRange?.active
					? {
						from: moment(filters?.dateRange?.from).format(
							'YYYY-MM-DD'
						),
						to: moment(filters?.dateRange?.to).format(
							'YYYY-MM-DD'
						),
					}
					: {},
			},
		});

		const { data = [] } = response;
		updateWastageImagesById(index, data);
		return data;
	};

	const fetchQCData = async (qcId) => {
		try {
			const req = {
				params: {
					qcId,
				},
			};

			const { data = null } = await liveQCServices.getPastData(req);

			return data;
		} catch {
			return null;
		}
	};

	const filtersInfo = {
		header : {
			store : false,
			statusAndTypes : false,
			product : false,
			date : false,
			process: false,
		},
		store : {
			text : 'Store',
			show : true,
		},
		processType : {
			text : 'Process Type',
			show : true,
		},
		identificationType : {
			text : 'Identification Type',
			show : true,
		},
		skuType : {
			text : 'SKU Type',
			show : true,
		},
		product : {
			text : 'Product',
			show : true,
		},
		dateRange : {
			text : 'Date Range',
			show : true,
		},
	}
	const exportInfo = {
		hideExportAccordian : true,
	};

	return (
		<div className={styles.root}>
			<DefectImageModal />
			<ImagesFinder
				filtersInfo={filtersInfo}
				onSubmit={submitFindRequest}
				exportInfo={exportInfo}
			/>
			<div className='flex justify-between m-4 '>
				<span className='font-bold text-[16px]'>Wastage Images </span>
				<Button
					onClick={() => {
						toggleFiltersDrawer(true);
					}}
					className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					<span>Filter</span>
					<Filter className='size-4' />
				</Button>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<div className='flex items-center gap-2'>
				<span>
					Page Limit : 
				</span>
				<SelectPicker
					data={[6, 25, 50, 100].map((item) => ({
						label: item,
						value: item,
					}))}
					value={pageLimit}
					onChange={(value) => setPageLimit(value)}
					searchable={false}
					className='w-[200px]'
				/>
			</div>
			<div className={styles['image-results']}>
				{allWastageResults?.map((product, index) => {
					return (
						product.Annotation.length > 0 && (
							<OutwardingImageResults
								key={product?.id}
								showLoadMore
								fetchImagesById={(req) => {
									fetchWastageImagesById(req, index);
								}}
								product={product}
								clickable
								extraLinkData='WASTAGE_IMAGES'
								fetchQCData={fetchQCData}
							/>
						)
					);
				})}
				{allWastageResults?.length === 0 && (
					<p className={styles.fallback}>No items to display</p>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { FIND_WASTAGE_IMAGES: allWastageResults } =
		state.analytics.WASTAGE_ANALYSIS;

	return {
		allWastageResults,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchWastageImages: (...args) => {
			dispatch(analyticsAction.gateway(...args));
		},
		updateWastageImagesById: (...args) => {
			dispatch(analyticsAction.updateWastageImagesList(...args));
		},
		resetWastageImages: () => {
			dispatch(analyticsAction.resetWastageImages());
		},
		toggleFiltersDrawer: (...args) => {
			dispatch(drawerActions.toggleFiltersDrawer(...args));
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(WastageImagesPage);
